<template>
  <x-page title="支付结果">
    <x-result
      title="支付成功"
      :message="goodType === 'std' ? '我们将尽快为您安排发货' : ''"
      confirm-text="查看订单"
      guess-resource-position-id="8aaa92be7b66c738017b779b320000c4"
      :confirm-track="{
        name: '支付成功-查看订单',
        id: 'bf9c697c-a19a-49d4-9adf-68e0ea9307ff',
      }"
      @confirm="handleConfirmClick"
    />

    <!-- 盲盒弹窗 -->
    <div v-if="isShowAlert" class="blind-box-popup">
      <div class="blind-box-content">
        <img class="blind-box-img" src="./images/盲盒.png" alt="盲盒" />
        <img
          class="blind-box-btn"
          src="./images/去开盲盒.png"
          alt="去开盲盒"
          @click="handleOpenBlindBox"
        />
        <img
          class="blind-box-close"
          src="./images/关闭盲盒.png"
          alt="关闭"
          @click="handleClosePopup"
        />
      </div>
    </div>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { apiOrderOrderMarketingBoxTimesAdd } from '@/api'
  import { dcb } from '@dcb/jssdk'
  import { globalModel } from '@/model'
  import { redirectTo } from '@/router'
  import { Track } from '@/utils'

  export default Vue.extend({
    noKeepalive: true,

    mixins: [
      Track.provideMark(() => ({
        page: '支付结果',
      })),
    ],

    data() {
      return {
        goodType: 'std', //std:标店，book:标销
        isShowAlert: false,
        blindBoxUrl: '',
      }
    },
    async created() {
      const orderNo = this.$route.query.orderNo
      this.goodType = this.$route.query.goodType
      const { isShowAlert, url } = await apiOrderOrderMarketingBoxTimesAdd({
        orderNo,
      })

      if (!globalModel.state.inWeapp) {
        this.isShowAlert = isShowAlert
        this.blindBoxUrl = url
      }
    },

    methods: {
      // 点击查看订单
      handleConfirmClick() {
        redirectTo('OrderIndex', {
          active: 0,
        })
      },
      // 去开盲盒
      handleOpenBlindBox() {
        if (this.blindBoxUrl) {
          dcb.navigateTo({
            url: this.blindBoxUrl,
          })
        }
        this.isShowAlert = false
      },
      // 关闭弹窗
      handleClosePopup() {
        this.isShowAlert = false
      },
    },
  })
</script>

<style lang="scss" scoped>
  .blind-box-popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .blind-box-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .blind-box-img {
    width: 375px;
    height: auto;
  }

  .blind-box-btn {
    width: 234px;
    height: auto;
    margin-top: -75px;
    cursor: pointer;
  }

  .blind-box-close {
    width: 32px;
    height: 32px;
    margin-top: 15px;
    cursor: pointer;
  }
</style>
